import { render } from "./PayableElipsisMenu.vue?vue&type=template&id=07e47d8c"
import script from "./PayableElipsisMenu.vue?vue&type=script&lang=js"
export * from "./PayableElipsisMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__